import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "userManage";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    userManageList: {
      list: [],
      total: 0,
    },
  },
  actions: {
    //查询
    async getUserManageData({ commit }, payload) {
      let result = await api.get(
        `/api/User/SyncUserPage?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setList", result.data);
      }
      return result.data;
    },
    //搜索用户
    async searchUser(a, payload) {
      let result = await api.get(`/api/User/search/${payload}`);
      return result.data;
    },
    //引入用户
    // async intoUser(a, payload) {
    //   let result = await api.post(`/api/User/${payload}`);
    //   return result;
    // },
    async intoUser(a, payload) {
      let result = await api.post(`/api/User/IncludeUser`, payload);
      return result;
    },
    // 开启权限
    async isOnOFF(commit, payload) {
      let result = await api.put(
        `/api/User/SwithUserEnable/${payload.userId}/${payload.enable}`
      );
      return result;
    },
    //获取分配角色权限数据
    async getEditRole(a, payload) {
      let result = await api.get(`/api/User/EditSyncUserView/${payload}`);
      return result.data;
    },
    //获取角色下拉数据
    async getRoleData(a, payload) {
      let result = await api.get("/api/Role/GetRoleList?version=2");
      return result.data;
    },
    //修改
    async updateProofing(a, payload) {
      let result = await api.put(`/api/FishSample/${payload.id}`, payload.data);
      return result.data;
    },
    //用户角色分配
    async updateCharacter(a, payload) {
      let result = await api.put(`/api/User/SetRole`, payload);
      return result.data;
    },
  },
  mutations: {
    setList(state, payload) {
      state.userManageList = payload;
    },
    setOnOff(state, payload) {
      state.userManageList.list[payload.index].enable = !payload.enable;
    },
  },
  getters: {},
});

export default moduleName;
